export default __webpack_public_path__ + "static/media/Supplies.5e32d95e.svg";